<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  hover: {
    type: Boolean,
    default: true,
    required: false
  },
  outline: {
    type: Boolean,
    default: false,
    required: false
  },
  loading: {
    type: Boolean,
    default: false,
    required: false
  },
  active: {
    type: Boolean,
    default: false,
    required: false
  },
  activeColor: {
    type: String,
    default: "#FFBA35",
    required: false
  },
  to: {
    type: String,
    required: false
  },
  text: {
    type: String,
    required: false,
  },
})
const style = computed(() => {
  if (props.active && props.activeColor) {
    return {
      "--myColor1": props.activeColor,
      "--myColor2": props.activeColor
    }
  }
  return {}
})
</script>

<template>
  <div v-if="loading">
    <button :style="style" :class="{active, hover, outline}">
      <div class="loader"></div>
    </button>
  </div>
  <router-link v-else-if="to" :to="to">
    <button :style="style" :class="{active, hover, outline}">{{ text }}
      <slot/>
    </button>
  </router-link>
  <button :style="style" :class="{active, hover, outline}" v-else>{{ text }}
    <slot/>
  </button>
</template>

<style scoped lang="scss">
.loader {
  border: 5px solid #f3f3f3; /* Light grey */
  border-top: 5px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@property --myColor1 {
  syntax: '<color>';
  initial-value: #B7B7B8;
  inherits: false;
}

@property --myColor2 {
  syntax: '<color>';
  initial-value: #B7B7B8;
  inherits: false;
}

a {
  width: 100%;
}

button {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  --borderWidth: 2px;
  width: 100%;
  height: 60px;
  max-height: 100%;
  border-radius: 100px;
  outline: none;
  border: none;
  color: #F5F5F5;
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  font-weight: 600;
  background: linear-gradient(91.59deg, var(--myColor1), var(--myColor2));
  font-family: 'Gilroy', sans-serif;
  font-size: 16px;
  transition: --myColor1 0.3s, --myColor2 0.3s;

  &.outline {
    background: none;
    border: var(--borderWidth) solid var(--myColor1);
  }

  &.hover:hover, &.active {
    --myColor1: #FFBA35;
    --myColor2: #FD9F30;
  }

  &.hover, &.active {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
